import script from "./LiveFixtureDoubleMarketAll.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveFixtureDoubleMarketAll.vue?vue&type=script&setup=true&lang=js"

import "./LiveFixtureDoubleMarketAll.vue?vue&type=style&index=0&id=06d39ffe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d39ffe"]])

export default __exports__